import { memo } from 'react';

import { type ScopedPermissions, type ShortUrlResponse } from '@air/api/types';

import { useUpdateShareClipLink } from '~/components/SharePrivateClipModal/hooks/useUpdateShareClipLink';
import { SharePrivateContentSettings } from '~/components/SharePrivateContentModal/SharePrivateContentSettings/SharePrivateContentSettings';

type SharePrivateClipSettingsProps = {
  clipId: string;
  shortIdInfo: ShortUrlResponse;
  userPermissions: ScopedPermissions;
};

export const SharePrivateClipSettings = memo(
  ({ shortIdInfo, clipId, userPermissions }: SharePrivateClipSettingsProps) => {
    const { onShortUrlUpdate, isLoading } = useUpdateShareClipLink({ clipId, shortIdInfo });

    return (
      <SharePrivateContentSettings
        shortIdInfo={shortIdInfo}
        onShortUrlUpdate={onShortUrlUpdate}
        isLoading={isLoading}
        userPermissions={userPermissions}
      />
    );
  },
);

SharePrivateClipSettings.displayName = 'SharePrivateClipSettings';
